import React, { useState, useEffect } from 'react';
import { FaBox, FaExternalLinkAlt, FaClock, FaShoppingCart, FaSync } from 'react-icons/fa';
import Badge from '@/components/common/Badge';
import Card, { CardBody } from '@/components/common/Card';
import Button from '@/components/common/Button';
import FiltrosRepuestosMarketplace from './marketplace/FiltrosRepuestosMarketplace';
import toastService from '@/utils/toastService';

/**
 * Mock del inventario de repuestos externos integrado
 * Muestra repuestos propios + externos del proveedor
 */
const RepuestosExternosInventario = ({ onAgregarAlCarrito, carrito = [] }) => {
  const [loading, setLoading] = useState(false);
  const [syncLoading, setSyncLoading] = useState(false);
  const [repuestos, setRepuestos] = useState([]);
  const [filteredRepuestos, setFilteredRepuestos] = useState([]);
  
  // Filtros
  const [filters, setFilters] = useState({
    searchTerm: '',
    categoria: '',
    tipoStock: 'todos', // todos, disponibles, agotados
    ordenarPor: 'nombre',
    marcaVehiculo: '',
    modeloVehiculo: ''
  });

  // Catálogo exclusivo de repuestos teknoParts
  const mockRepuestos = [
    // Solo repuestos de teknoParts (proveedor exclusivo)
    {
      id: 101,
      nombre: 'Filtro de Aceite Toyota Premium',
      codigo: 'PROV-FO-TOY-P001',
      codigoProveedor: 'FO-TOY-PREM-2024',
      categoria: 'Filtros',
      precioOriginal: 26667, // Precio original sin descuento (24000 / 0.9)
      descuentoProveedor: 10, // 10% descuento teknoParts
      precio: 25200, // Precio proveedor + 5% comisión (24000 * 1.05)
      precioProveedor: 24000, // Precio del proveedor con descuento
      comision: 1200, // 5% de comisión
      margenTaller: 0, // Sin margen adicional para taller
      tieneDescuento: true,
      stock: 0, // No hay stock propio
      stockExterno: 150, // Stock del proveedor
      esExterno: true,
      proveedor: {
        id: 1,
        nombre: 'teknoParts',
        logo: '/img/marketplace/teknoparts.png'
      },
      tiempoEntrega: 1, // días
      imagen: 'https://via.placeholder.com/300x200/374151/9CA3AF?text=Filtro+de+Aceite',
      disponible: true,
      descripcion: 'Filtro de aceite premium Toyota con tecnología avanzada'
    },
    {
      id: 102,
      nombre: 'Kit Pastillas de Freno Performance',
      codigo: 'PROV-PF-PERF-001',
      codigoProveedor: 'PF-PERFORMANCE-KIT',
      categoria: 'Frenos',
      precioOriginal: 72222, // Precio original sin descuento (65000 / 0.9)
      descuentoProveedor: 10, // 10% descuento teknoParts
      precio: 68250, // Precio proveedor + 5% comisión (65000 * 1.05)
      precioProveedor: 65000,
      comision: 3250,
      margenTaller: 0,
      tieneDescuento: true,
      stock: 0,
      stockExterno: 45,
      esExterno: true,
      proveedor: {
        id: 1,
        nombre: 'teknoParts',
        logo: '/img/marketplace/teknoparts.png'
      },
      tiempoEntrega: 2,
      imagen: 'https://via.placeholder.com/300x200/374151/9CA3AF?text=Pastillas+de+Freno',
      disponible: true,
      descripcion: 'Kit completo de pastillas de freno de alto rendimiento'
    },
    {
      id: 103,
      nombre: 'Amortiguador Delantero Izquierdo',
      codigo: 'PROV-AM-DEL-IZQ-001',
      codigoProveedor: 'AM-MONROE-DEL-L',
      categoria: 'Suspensión',
      precioOriginal: 105556, // Precio original sin descuento (95000 / 0.9)
      descuentoProveedor: 10, // 10% descuento teknoParts
      precio: 99750, // Precio proveedor + 5% comisión (95000 * 1.05)
      precioProveedor: 95000,
      comision: 4750,
      margenTaller: 0,
      tieneDescuento: true,
      stock: 0,
      stockExterno: 12,
      esExterno: true,
      proveedor: {
        id: 1,
        nombre: 'teknoParts',
        logo: '/img/marketplace/teknoparts.png'
      },
      tiempoEntrega: 3,
      imagen: 'https://via.placeholder.com/300x200/374151/9CA3AF?text=Amortiguador',
      disponible: true,
      descripcion: 'Amortiguador Monroe para suspensión delantera - teknoParts'
    },
    {
      id: 104,
      nombre: 'Turbo Reconstruido BMW N54',
      codigo: 'TKP-TURBO-BMW-N54',
      codigoProveedor: 'TURBO-BMW-N54-REMAN',
      categoria: 'Motor',
      precioOriginal: 388889, // Precio original sin descuento (350000 / 0.9)
      descuentoProveedor: 10, // 10% descuento teknoParts
      precio: 367500, // Precio proveedor + 5% comisión (350000 * 1.05)
      precioProveedor: 350000,
      comision: 17500,
      margenTaller: 0,
      tieneDescuento: true,
      stock: 0,
      stockExterno: 3,
      esExterno: true,
      proveedor: {
        id: 1,
        nombre: 'teknoParts',
        logo: '/img/marketplace/teknoparts.png'
      },
      tiempoEntrega: 5,
      imagen: 'https://via.placeholder.com/300x200/374151/9CA3AF?text=Turbo+BMW',
      disponible: true,
      descripcion: 'Turbo reconstruido BMW N54 con garantía 12 meses - teknoParts'
    },
    {
      id: 105,
      nombre: 'Kit Distribución Completo Audi',
      codigo: 'TKP-KIT-DIST-AUDI',
      codigoProveedor: 'KIT-TIMING-AUDI-2.0T',
      categoria: 'Motor',
      precioOriginal: 155556, // Precio original sin descuento (140000 / 0.9)
      descuentoProveedor: 10, // 10% descuento teknoParts
      precio: 147000, // Precio proveedor + 5% comisión (140000 * 1.05)
      precioProveedor: 140000,
      comision: 7000,
      margenTaller: 0,
      tieneDescuento: true,
      stock: 0,
      stockExterno: 8,
      esExterno: true,
      proveedor: {
        id: 1,
        nombre: 'teknoParts',
        logo: '/img/marketplace/teknoparts.png'
      },
      tiempoEntrega: 2,
      imagen: 'https://via.placeholder.com/300x200/374151/9CA3AF?text=Kit+Distribucion',
      disponible: true,
      descripcion: 'Kit de distribución completo Audi 2.0T incluye bomba de agua - teknoParts'
    },
    {
      id: 106,
      nombre: 'Radiador Toyota Corolla',
      codigo: 'TKP-RAD-TOY-COR',
      codigoProveedor: 'RAD-TOYOTA-COROLLA-2020',
      categoria: 'Refrigeración',
      precioOriginal: 83333, // Precio original sin descuento (75000 / 0.9)
      descuentoProveedor: 10, // 10% descuento teknoParts
      precio: 78750, // Precio proveedor + 5% comisión (75000 * 1.05)
      precioProveedor: 75000,
      comision: 3750,
      margenTaller: 0,
      tieneDescuento: true,
      stock: 0,
      stockExterno: 6,
      esExterno: true,
      proveedor: {
        id: 1,
        nombre: 'teknoParts',
        logo: '/img/marketplace/teknoparts.png'
      },
      tiempoEntrega: 3,
      imagen: 'https://via.placeholder.com/300x200/374151/9CA3AF?text=Radiador+Toyota',
      disponible: true,
      descripcion: 'Radiador original Toyota Corolla 2020-2023 - teknoParts'
    }
  ];


  useEffect(() => {
    fetchRepuestos();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [repuestos, filters]);


  const fetchRepuestos = async () => {
    setLoading(true);
    try {
      // Simular llamada API
      await new Promise(resolve => setTimeout(resolve, 1000));
      setRepuestos(mockRepuestos);
    } catch (error) {
      toastService.error('Error al cargar repuestos');
    } finally {
      setLoading(false);
    }
  };

  const syncProveedores = async () => {
    setSyncLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 2000));
      toastService.success('Sincronización completada con teknoParts');
      fetchRepuestos();
    } catch (error) {
      toastService.error('Error en sincronización');
    } finally {
      setSyncLoading(false);
    }
  };

  const applyFilters = () => {
    let filtered = [...repuestos];

    // Filtro por término de búsqueda
    if (filters.searchTerm) {
      const term = filters.searchTerm.toLowerCase();
      filtered = filtered.filter(r => 
        r.nombre.toLowerCase().includes(term) ||
        r.codigo.toLowerCase().includes(term) ||
        (r.codigoProveedor && r.codigoProveedor.toLowerCase().includes(term))
      );
    }

    // Filtro por vehículo (marca y modelo)
    if (filters.marcaVehiculo) {
      const marcaTerm = filters.marcaVehiculo.toLowerCase();
      filtered = filtered.filter(r => {
        // Buscar en el nombre del repuesto si contiene la marca
        const nombreContieneMarca = r.nombre.toLowerCase().includes(marcaTerm);
        // También buscar en descripción si existe
        const descripcionContieneMarca = r.descripcion && r.descripcion.toLowerCase().includes(marcaTerm);
        return nombreContieneMarca || descripcionContieneMarca;
      });
    }

    if (filters.modeloVehiculo) {
      const modeloTerm = filters.modeloVehiculo.toLowerCase();
      filtered = filtered.filter(r => {
        // Buscar en el nombre del repuesto si contiene el modelo
        const nombreContieneModelo = r.nombre.toLowerCase().includes(modeloTerm);
        // También buscar en descripción si existe
        const descripcionContieneModelo = r.descripcion && r.descripcion.toLowerCase().includes(modeloTerm);
        return nombreContieneModelo || descripcionContieneModelo;
      });
    }

    // Filtro por categoría
    if (filters.categoria) {
      filtered = filtered.filter(r => 
        r.categoria.toLowerCase() === filters.categoria.toLowerCase()
      );
    }

    // Filtro por disponibilidad (solo teknoParts)
    switch (filters.tipoStock) {
      case 'disponibles':
        filtered = filtered.filter(r => r.stockExterno > 0);
        break;
      case 'agotados':
        filtered = filtered.filter(r => r.stockExterno === 0);
        break;
      // Todos los productos son de teknoParts, no necesitamos más filtros
    }

    // Ordenar
    filtered.sort((a, b) => {
      switch (filters.ordenarPor) {
        case 'precio':
          return a.precio - b.precio;
        case 'stock':
          return b.stockExterno - a.stockExterno;
        case 'descuento':
          return b.descuentoProveedor - a.descuentoProveedor;
        case 'nombre':
        default:
          return a.nombre.localeCompare(b.nombre);
      }
    });

    setFilteredRepuestos(filtered);
  };


  const getStockDisplay = (repuesto) => {
    if (!repuesto.esExterno) {
      return {
        texto: `${repuesto.stock} unidades`,
        color: repuesto.stock <= repuesto.stockMinimo ? 'text-red-400' : 'text-green-400',
        badge: repuesto.stock <= repuesto.stockMinimo ? 'danger' : 'success'
      };
    } else {
      return {
        texto: repuesto.stockExterno > 0 ? `${repuesto.stockExterno} disponibles` : 'Agotado',
        color: repuesto.stockExterno > 0 ? 'text-blue-400' : 'text-red-400',
        badge: repuesto.stockExterno > 0 ? 'info' : 'danger'
      };
    }
  };

  const isEnCarrito = (repuestoId) => {
    return carrito.some(item => item.id === repuestoId);
  };

  return (
    <div>
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center">
          <div className="w-1 h-6 rounded-full mr-3 bg-blue-500" />
          <h1 className="text-2xl font-bold">Catálogo teknoParts</h1>
        </div>
        
        {/* Solo en escritorio: Stats inline con botón */}
        <div className="hidden lg:flex items-center flex-1 justify-center gap-3 mx-6">
          <Card className="bg-blue-900/20 border-blue-800/50 w-36">
            <CardBody className="px-4 py-2">
              <div className="text-center">
                <p className="text-xs text-gray-400 mb-1">Total teknoParts</p>
                <div className="flex items-center justify-center">
                  <FaExternalLinkAlt className="text-blue-400 text-xl mr-2" />
                  <p className="text-xl font-bold">
                    {repuestos.length}
                  </p>
                </div>
              </div>
            </CardBody>
          </Card>

          <Card className="bg-green-900/20 border-green-800/50 w-36">
            <CardBody className="px-4 py-2">
              <div className="text-center">
                <p className="text-xs text-gray-400 mb-1">Disponibles</p>
                <div className="flex items-center justify-center">
                  <FaClock className="text-green-400 text-xl mr-2" />
                  <p className="text-xl font-bold">
                    {repuestos.filter(r => r.stockExterno > 0).length}
                  </p>
                </div>
              </div>
            </CardBody>
          </Card>

          <Card className="bg-purple-900/20 border-purple-800/50 w-36">
            <CardBody className="px-4 py-2">
              <div className="text-center">
                <p className="text-xs text-gray-400 mb-1">En Carrito</p>
                <div className="flex items-center justify-center">
                  <FaShoppingCart className="text-purple-400 text-xl mr-2" />
                  <p className="text-xl font-bold">{carrito.length}</p>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
        
        {/* Botón para escritorio */}
        <div className="hidden lg:block">
          <Button
            variant="secondary"
            onClick={syncProveedores}
            loading={syncLoading}
            icon={<FaSync />}
          >
            Sincronizar teknoParts
          </Button>
        </div>
        
        {/* Solo en móvil/tablet: Botón separado */}
        <div className="lg:hidden">
          <Button
            variant="secondary"
            onClick={syncProveedores}
            loading={syncLoading}
            icon={<FaSync />}
          >
            Sincronizar teknoParts
          </Button>
        </div>
      </div>

      {/* Stats rápidas - solo en móvil/tablet */}
      <div className="lg:hidden grid grid-cols-2 gap-6 mb-6">
        <Card className="bg-blue-900/20 border-blue-800/50">
          <CardBody className="p-4">
            <div className="text-center">
              <p className="text-xs text-gray-400 mb-1">Total teknoParts</p>
              <div className="flex items-center justify-center">
                <FaExternalLinkAlt className="text-blue-400 text-xl mr-2" />
                <p className="text-xl font-bold">
                  {repuestos.length}
                </p>
              </div>
            </div>
          </CardBody>
        </Card>

        <Card className="bg-green-900/20 border-green-800/50">
          <CardBody className="p-4">
            <div className="text-center">
              <p className="text-xs text-gray-400 mb-1">Disponibles</p>
              <div className="flex items-center justify-center">
                <FaClock className="text-green-400 text-xl mr-2" />
                <p className="text-xl font-bold">
                  {repuestos.filter(r => r.stockExterno > 0).length}
                </p>
              </div>
            </div>
          </CardBody>
        </Card>

        <Card className="bg-purple-900/20 border-purple-800/50">
          <CardBody className="p-4">
            <div className="text-center">
              <p className="text-xs text-gray-400 mb-1">En Carrito</p>
              <div className="flex items-center justify-center">
                <FaShoppingCart className="text-purple-400 text-xl mr-2" />
                <p className="text-xl font-bold">{carrito.length}</p>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>

      {/* Filtros avanzados */}
      <FiltrosRepuestosMarketplace
        onSearch={(value) => setFilters({...filters, searchTerm: value})}
        searchValue={filters.searchTerm}
        onVehiculoChange={(vehiculo) => setFilters({
          ...filters, 
          marcaVehiculo: vehiculo.marca, 
          modeloVehiculo: vehiculo.modelo
        })}
        marcaVehiculo={filters.marcaVehiculo}
        modeloVehiculo={filters.modeloVehiculo}
        onCategoriaChange={(categoria) => setFilters({...filters, categoria})}
        categoriaSeleccionada={filters.categoria}
        onTipoStockChange={(tipoStock) => setFilters({...filters, tipoStock})}
        tipoStockSeleccionado={filters.tipoStock}
        onOrdenarPorChange={(ordenarPor) => setFilters({...filters, ordenarPor})}
        ordenarPorSeleccionado={filters.ordenarPor}
        onReset={() => setFilters({
          categoria: '', 
          searchTerm: '', 
          tipoStock: 'todos', 
          ordenarPor: 'nombre',
          marcaVehiculo: '',
          modeloVehiculo: ''
        })}
        categorias={['Filtros', 'Frenos', 'Suspensión', 'Motor', 'Refrigeración']}
      />

      {/* Lista de repuestos */}
      {loading ? (
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredRepuestos.map(repuesto => {
            const stockInfo = getStockDisplay(repuesto);
            const enCarrito = isEnCarrito(repuesto.id);
            
            return (
              <Card 
                key={repuesto.id} 
                className={`transition-all duration-300 ${
                  repuesto.esExterno 
                    ? 'border-l-4 border-l-blue-500' 
                    : 'border-l-4 border-l-green-500'
                }`}
                hover
              >
                <CardBody className="p-0">
                  {/* Imagen del producto */}
                  <div className="relative">
                    <img 
                      src={repuesto.imagen} 
                      alt={repuesto.nombre}
                      className="w-full h-48 object-cover"
                      onError={(e) => {
                        e.target.src = 'https://images.unsplash.com/photo-1486262715619-67b85e0b08d3?w=300&h=200&fit=crop&auto=format&q=80';
                      }}
                    />
                    
                    {/* Badges superiores */}
                    <div className="absolute top-2 left-2 flex gap-2">
                      <Badge 
                        variant={repuesto.esExterno ? 'info' : 'success'}
                        size="sm"
                      >
                        {repuesto.esExterno ? 'teknoParts' : 'Propio'}
                      </Badge>
                      
                      {repuesto.esExterno && repuesto.tiempoEntrega <= 1 && (
                        <Badge variant="warning" size="sm">
                          Express
                        </Badge>
                      )}
                      
                      {repuesto.tieneDescuento && repuesto.esExterno && (
                        <Badge variant="success" size="sm">
                          -{repuesto.descuentoProveedor}% OFF
                        </Badge>
                      )}
                    </div>

                    {/* Badge de stock */}
                    <div className="absolute top-2 right-2">
                      <Badge variant={stockInfo.badge} size="sm">
                        {stockInfo.texto}
                      </Badge>
                    </div>

                    {/* Badge de categoría */}
                    <div className="absolute bottom-2 right-2">
                      <Badge variant="secondary" size="sm">
                        {repuesto.categoria}
                      </Badge>
                    </div>
                  </div>

                  {/* Información del producto */}
                  <div className="p-4">
                    <div className="mb-3">
                      <h3 className="font-semibold text-lg mb-1">{repuesto.nombre}</h3>
                      <p className="text-sm text-gray-400">{repuesto.descripcion}</p>
                    </div>

                    {/* Layout de dos columnas: info técnica izquierda, precios derecha */}
                    <div className="mb-4 flex gap-4">
                      {/* Columna izquierda: Códigos y proveedor */}
                      <div className="flex-1 space-y-3">
                        {/* Códigos */}
                        <div className="space-y-1">
                          <p className="text-xs text-gray-500">
                            <span className="font-medium">Código:</span> {repuesto.codigo}
                          </p>
                          {repuesto.codigoProveedor && (
                            <p className="text-xs text-gray-500">
                              <span className="font-medium">Código teknoParts:</span> {repuesto.codigoProveedor}
                            </p>
                          )}
                        </div>

                        {/* Proveedor (si es externo) */}
                        {repuesto.esExterno && repuesto.proveedor && (
                          <div className="flex items-center">
                            <img 
                              src={repuesto.proveedor.logo} 
                              alt={repuesto.proveedor.nombre}
                              className="w-5 h-5 rounded mr-2"
                            />
                            <span className="text-sm text-gray-400">{repuesto.proveedor.nombre}</span>
                            {repuesto.tiempoEntrega > 0 && (
                              <span className="ml-2 text-xs text-yellow-400">
                                • {repuesto.tiempoEntrega} día{repuesto.tiempoEntrega > 1 ? 's' : ''}
                              </span>
                            )}
                          </div>
                        )}

                        {/* Ubicación (si es propio) */}
                        {!repuesto.esExterno && repuesto.ubicacion && (
                          <p className="text-sm text-gray-400">
                            <span className="font-medium">Ubicación:</span> {repuesto.ubicacion}
                          </p>
                        )}
                      </div>

                      {/* Columna derecha: Solo precios */}
                      <div className="flex flex-col items-end justify-start">
                        {/* Precios */}
                        <div className="text-right">
                          {repuesto.tieneDescuento && repuesto.esExterno ? (
                            <div className="flex items-center gap-2 justify-end mb-1">
                              <span className="text-sm text-gray-400 line-through">
                                ${repuesto.precioOriginal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                              </span>
                              <Badge variant="success" size="xs">
                                -{repuesto.descuentoProveedor}%
                              </Badge>
                            </div>
                          ) : null}
                          <span className="text-2xl font-bold text-green-400">
                            ${repuesto.precio.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
                          </span>
                        </div>
                      </div>
                    </div>

                    {/* Botón de acción */}
                    <Button
                      variant={enCarrito ? "success" : "primary"}
                      fullWidth
                      disabled={!repuesto.disponible || enCarrito}
                      onClick={() => onAgregarAlCarrito(repuesto)}
                      icon={<FaShoppingCart />}
                    >
                      {enCarrito ? 'En Carrito' : 
                       !repuesto.disponible ? 'No Disponible' : 
                       'Agregar al Carrito'}
                    </Button>
                  </div>
                </CardBody>
              </Card>
            );
          })}
        </div>
      )}

      {filteredRepuestos.length === 0 && !loading && (
        <div className="text-center py-12">
          <FaBox className="mx-auto text-6xl text-gray-600 mb-4" />
          <h3 className="text-xl font-semibold mb-2">No se encontraron productos teknoParts</h3>
          <p className="text-gray-400">Intenta ajustar los filtros de búsqueda o sincronizar el catálogo</p>
        </div>
      )}
    </div>
  );
};

export default RepuestosExternosInventario;